import {
  REQUEST_PERFORMANCE_DATA,
  PERFORMANCE_DATA_FAILED,
  PERFORMANCE_DATA_SUCCESS,
} from '../actions/types';

export const performanceReducers = (
  state = {
    loading: true,
  },
  action,
) => {
  switch (action.type) {
    case REQUEST_PERFORMANCE_DATA:
      return { loading: true };
    case PERFORMANCE_DATA_SUCCESS:
      return { loading: false, data: action.payload };
    case PERFORMANCE_DATA_FAILED:
      return { loading: false };
    default:
      return state;
  }
};
